<template>
  <div>{{ verification_in_progress }} {{ verified }}</div>
</template>

<script>
import { verifyEmail } from "../services/api";
export default {
  name: "Register",
  data() {
    return {
      verification_in_progress: true,
      verified: false
    };
  },
  methods: {
    async verify() {
      const verificationToken = this.$router.currentRoute.query
        .verificationToken;
      if (verificationToken) {
        const result = await verifyEmail(verificationToken);
        this.verification_in_progress = false;
        if (result.data) {
          this.verified = true;
        }
      }
    }
  },
  created: function() {
    this.verify();
  }
};
</script>

<style scoped></style>
